var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-box"},[_c('keep-alive',{attrs:{"include":_vm.includes}},[_c(_vm.currentView,{tag:"component",attrs:{"active":_vm.active},on:{"toggle":_vm.toggle}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }